//#region : Toast Handling :
/**
 * Shows a toast message.
 * @param {Object} context - The context object containing state and commit function.
 * @param {string} message - The message to be displayed in the toast.
 */
const showToast = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast');

  setTimeout(() => {
    commit('showToast', {
      color: 'black',
      message,
      timeout: 3000
    });
  });
};

/**
 * Shows an error toast message.
 * @param {Object} context - The Vuex context object.
 * @param {Error} error - The error object to display.
 */
const showError = ({ state, commit }, error) => {
  if (state.toast.show) commit('hideToast');

  setTimeout(() => {
    commit('showToast', {
      color: 'error',
      message: error.toString(),
      timeout: 10000
    });
  });
};

/**
 * Shows a success toast message.
 * @param {Object} context - The Vuex context object.
 * @param {string} message - The success message to display.
 */
const showSuccess = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast');

  setTimeout(() => {
    commit('showToast', {
      color: 'success',
      message,
      timeout: 3000
    });
  });
};
//#endregion

export default {
  showToast,
  showError,
  showSuccess
};
